// Captures the URL hash once, synchronously, at module-evaluation time — before
// the Supabase client's async `detectSessionInUrl` can strip it. A password
// recovery / set-password link carries its token (or, when expired/used, an
// error) in the hash. If such a link lands on the wrong route — most commonly
// the Site URL homepage, which is where Supabase falls back when a link's
// `redirect_to` isn't in the allow-list (e.g. an old link) — this lets the app
// still route it to /reset-password so the user sees the right screen instead
// of a confusing homepage.
//
// Imported first in index.js so it evaluates before the Supabase client.

const initialHash =
  typeof window !== "undefined" ? window.location.hash || "" : "";

/** The URL hash as it was on first page load. */
export function getInitialAuthHash() {
  return initialHash;
}

/**
 * True when a hash looks like it came from an auth recovery / set-password link
 * — either a recovery token or an auth error (expired/used link).
 * @param {string} hash e.g. "#access_token=...&type=recovery" or
 *   "#error=access_denied&error_code=otp_expired".
 */
export function isRecoveryOrAuthErrorHash(hash) {
  if (!hash) return false;
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  return (
    params.get("type") === "recovery" ||
    params.has("error") ||
    params.has("error_code") ||
    params.has("error_description")
  );
}
